var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gamePage"}},[_c('iframe',{ref:"game",staticClass:"iframe",style:(("height:" + _vm.iframeHeight + ";")),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }